/**
 * @generated SignedSource<<c9e40b18348f37a633a09bc62b90bbbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addressYmdgQuery$variables = {
  sggNm?: string | null | undefined;
  sidoNm?: string | null | undefined;
};
export type addressYmdgQuery$data = {
  readonly getSurveyAddress: ReadonlyArray<{
    readonly ymdgNm: string | null | undefined;
  }>;
};
export type addressYmdgQuery = {
  response: addressYmdgQuery$data;
  variables: addressYmdgQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sggNm"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sidoNm"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "sggNm",
        "variableName": "sggNm"
      },
      {
        "kind": "Variable",
        "name": "sidoNm",
        "variableName": "sidoNm"
      }
    ],
    "concreteType": "RefundUserGetSurveyAddressOutput",
    "kind": "LinkedField",
    "name": "getSurveyAddress",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ymdgNm",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "addressYmdgQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "addressYmdgQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "e361434ece4ce0ac9ffd5fcf086dc97c",
    "id": null,
    "metadata": {},
    "name": "addressYmdgQuery",
    "operationKind": "query",
    "text": "query addressYmdgQuery(\n  $sidoNm: String\n  $sggNm: String\n) {\n  getSurveyAddress(sidoNm: $sidoNm, sggNm: $sggNm) {\n    ymdgNm\n  }\n}\n"
  }
};
})();

(node as any).hash = "434eea5a23fb401b6fee910eb3f1e6d8";

export default node;
